import RessourcesTable from './RessourcesTable'
export default RessourcesTable